import { takeLatest, all, put, call } from 'redux-saga/effects';
import { uniq, flatMap } from 'lodash';
import { compose } from '@adjust/dashboard-core/lib/fp';
import { getFirstError } from '@adjust/dashboard-core/lib/errorMessage/errorMessage';
import { changePassword } from '@api/user';
import {
  CHANGE_PASSWORD_STARTED,
  changePasswordSucceeded,
  changePasswordFailed,
  changePasswordFinally,
} from '@redux/ducks/userDetails/editUserPassword';

const errorMessages = {
  invalid: 'error.invalid_password',
  too_short: 'field.password.error.too-short',
};

// watchers

export function* watchChangePassword() {
  yield takeLatest(CHANGE_PASSWORD_STARTED, changePasswordTask);
}

// workers

export function* changePasswordTask({ payload }) {
  const { response, error } = yield call(changePassword, payload);
  if (response) {
    yield put(changePasswordSucceeded());
  } else {
    yield put(createChangePasswordFailed(error, errorMessages));
  }
  yield put(changePasswordFinally());
}

// saga

export default function* userEditPasswordSaga() {
  yield all([watchChangePassword()]);
}

// utils
const createChangePasswordFailed = compose(changePasswordFailed, getErrorMessage);

function getErrorMessage(errorData, errorMessages) {
  const errors = compose(uniq, flatMap)(errorData);
  if (errorData && errorData.new_password && !errorData.password) {
    return errorData.new_password;
  } else {
    return getFirstError(errors, errorMessages);
  }
}
